import { suggestions as tweakwiseSuggestions } from "@jog/shared";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
export const useSuggestions = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [isSearchShown, setIsSearchShown] = useState(false);
    const [suggestions, setSuggestions] = useState(null);
    const onSearch = useCallback(async () => {
        if (searchTerm.trim().length > 2) {
            await tweakwiseSuggestions(searchTerm)
                .then((res) => res.body)
                .then((res) => {
                setSuggestions(res);
                setIsSearchShown(true);
            })
                .catch(() => {
                setIsSearchShown(false);
            });
        }
        else {
            setSuggestions(null);
            setIsSearchShown(false);
        }
    }, [searchTerm]);
    const timer = useRef(null);
    useEffect(() => {
        if (timer.current) {
            clearTimeout(timer.current);
            timer.current = null;
        }
        timer.current = setTimeout(async () => {
            await onSearch();
        }, 300);
        return () => {
            if (timer.current)
                clearTimeout(timer.current);
        };
    }, [onSearch]);
    const router = useRouter();
    const handleSearch = useCallback(async (searchTerm) => {
        if (searchTerm) {
            setIsSearchShown(false);
            if (router.pathname === "/search") {
                await router.replace({ pathname: "/search", query: { tn_q: searchTerm } });
            }
            else {
                await router.push({ pathname: "/search", query: { tn_q: searchTerm } });
            }
        }
    }, [router, setIsSearchShown]);
    return {
        isSearchShown: useMemo(() => {
            var _a, _b, _c, _d;
            return isSearchShown &&
                !!(((_a = suggestions === null || suggestions === void 0 ? void 0 : suggestions.searchPhrases) === null || _a === void 0 ? void 0 : _a.length) ||
                    ((_b = suggestions === null || suggestions === void 0 ? void 0 : suggestions.categories) === null || _b === void 0 ? void 0 : _b.length) ||
                    ((_d = (_c = suggestions === null || suggestions === void 0 ? void 0 : suggestions.products) === null || _c === void 0 ? void 0 : _c.items) === null || _d === void 0 ? void 0 : _d.length));
        }, [isSearchShown, suggestions]),
        suggestions,
        searchTerm,
        setSearchTerm,
        setIsSearchShown,
        handleSearch,
    };
};
